import React from 'react';
import DOMPurify from 'dompurify';

import { componentTypes } from '@white-nl/instantsearch-components';
import Picture from '../../../ui/Picture';
import {
  CloudArrowDownClassicRegular,
  CloudArrowDownClassicSolid,
  UpRightFromSquareSolid,
  UpRightFromSquareRegular,
} from '../../../ui/icons';

export default function Hit({ hit }: componentTypes.HitProps) {
  const {
    title,
    download,
    downloadLink,
    image,
    description,
  } = hit;

  const language = download && download.language ? download.language : '';

  let hrefLink = '';
  if (download) {
    hrefLink = download.url;
  } else if (downloadLink) {
    hrefLink = downloadLink.value;
  }

  let linkTarget = '_blank';
  if (!download && downloadLink && downloadLink.target) {
    linkTarget = downloadLink.target;
  }

  return (
    <div className="col-12 col-md-6 col-lg-4">
      <a className="card-downloads vertical" href={hrefLink} download={download ? true : undefined} target={linkTarget} rel="noreferrer">
        <div className="card-downloads-img" style={{ padding: image ? '0' : '12px 0' }}>
          {image && (<Picture image={image} defaultTransform="all" loading="lazy" />)}
          {!image && (
            <div className="card-downloads-img__placeholder">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path d="M320 496c26.5 0 48-21.5 48-48V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320zm41.1-336c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM0 64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z" />
              </svg>
            </div>
          )}
        </div>
        <div className="card-downloads-top">
          {/* eslint-disable-next-line react/no-danger */}
          <h2 className="h4" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }} />
          {description && (
            /* eslint-disable-next-line react/no-danger */
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }} />
          )}
        </div>
        <div className="card-downloads-foot">
          <span className="text-format">
            {download && (
              <>
                <span className="icon">
                  <CloudArrowDownClassicSolid iconClass="hover-icon" />
                  <CloudArrowDownClassicRegular />
                </span>
                <b>
                  {download.kind.toUpperCase()}
                  {language && (
                    <>
                      {' | '}
                      {language}
                    </>
                  )}
                </b>
                <span className="note">
                  {`[ ${download.size} ]`}
                </span>
              </>
            )}
            {!download && downloadLink && (
              <>
                <span className="icon">
                  <UpRightFromSquareSolid iconClass="hover-icon" />
                  <UpRightFromSquareRegular />
                </span>
                {downloadLink.label && (
                  <b>
                    {downloadLink.label}
                  </b>
                )}
              </>
            )}
          </span>
        </div>
      </a>
    </div>
  );
}
